import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { fetchCategoryDetail, createCategory, updateCategory } from 'actions/Categories'
import FormCategoryView from 'components/pages/categories/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'
import Browser from 'utils/Browser'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchCategoryDetail: bindActionCreators(fetchCategoryDetail, dispatch),
  createCategory: bindActionCreators(createCategory, dispatch),
  updateCategory: bindActionCreators(updateCategory, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const {
        setData, setImgFile, setCurrentImg,
      } = props

      try {
        const res = await props.fetchCategoryDetail(id)
        setData(res)
        setImgFile(res.logo_path)
        setCurrentImg(res.logo_path)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleSubmit: props => (values) => {
      let payload

      props.setIsSubmit(true)

      if (props.imgFile === props.currentImg) {
        payload = {
          ...values,
        }
        delete payload.logo_file
      } else {
        payload = {
          ...values,
          logo_file: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updateCategory(props.match.params.id, payload)
          .then(() => {
            message.success('Kategori sudah diperbarui')
            props.setIsSubmit(false)
            props.setImgFile('')
            Browser.setWindowHref('/category')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createCategory(payload)
          .then(() => {
            message.success('Kategori sudah dibuat')
            props.setIsSubmit(false)
            props.setImgFile('')
            Browser.setWindowHref('/category')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { match, setIsEdit, getDetail } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Form Kategori',
        activePage: 'category',
        activeSubPage: 'category',
      })
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormCategoryView)
